<template>
  <div class="relative w-full">
    <tutorial-start :show="isCurrent(1)" @next="next" @skip="leave" />
    <feet-pos :show="isCurrent(2)" @next="next" @skip="leave" />
    <clench-fingers1 :show="isCurrent(3)" @next="next" @skip="leave" />
    <clench-fingers2 :show="isCurrent(4)" @next="next" @skip="leave" />
    <hand-raise-ready :show="isCurrent(5)" @next="next" @skip="leave" />
  </div>
</template>

<script>
import audioPlayer from '@/mixins/audio-player';

import TutorialStart from '@/components/Stamp/Tutorial/TutorialStart.vue';
import FeetPos from '@/components/Stamp/Tutorial/FeetPos.vue';
import ClenchFingers1 from '@/components/Stamp/Tutorial/ClenchFingers1.vue';
import ClenchFingers2 from '@/components/Stamp/Tutorial/ClenchFingers2.vue';
import HandRaiseReady from '@/components/Stamp/Tutorial/HandRaiseReady.vue';

import leave from '@/mixins/leave';

export default {
  name: 'Tutorial',
  mixins: [leave, audioPlayer],
  components: {
    TutorialStart,
    FeetPos,
    ClenchFingers1,
    ClenchFingers2,
    HandRaiseReady,
  },
  data: () => ({
    currentPageNo: 1,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.$events.goto('StampChooseToStart');
      }
      // play audio through page 3 and 4
      if (newPage === 3) {
        this.playAudio('v13_3');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    lastScreen() {
      return this.currentPageNo >= 5;
    },
  },
};
</script>
